import angular from 'angular';

import 'angular-translate';

import translationServiceModule from './service/TranslationService';
import { DEFAULT_LOCALE } from './constants';

const moduleName = 'recap.translations';
let module = angular.module(moduleName, [
  'pascalprecht.translate',
  translationServiceModule.name,
]);

module.factory('customTranslationLoader', function($http, $q, TranslationService) {
  let promisesByLanguageKey = {};
  return function(options) {
    const lang = options.key || DEFAULT_LOCALE;
    if (!(lang in promisesByLanguageKey)) {
      promisesByLanguageKey[lang] = TranslationService.loadTranslations(lang);
    }
    return promisesByLanguageKey[lang];
  };
});

module.factory('customTranslationHandler', function(TranslationService, $log) {
  let missingKeys = {};
  return function(translationKey) {
    if (missingKeys[translationKey] === undefined) {
      $log.warn('Missing translation:', translationKey);
      missingKeys[translationKey] = TranslationService.convertKeyToCapitalizedSentence(translationKey);
      $log.info("Using", missingKeys[translationKey], "for translation of", translationKey);
    }
    return missingKeys[translationKey];
  };
});

module.config($translateProvider => {
  $translateProvider.useLoader('customTranslationLoader');
  $translateProvider.useMissingTranslationHandler('customTranslationHandler');
  $translateProvider.preferredLanguage(DEFAULT_LOCALE);
  $translateProvider.useSanitizeValueStrategy('sce');
});

export default moduleName;
